import { render, staticRenderFns } from "./ActivationPaymentsPreviewRouterView.vue?vue&type=template&id=84fbfa5a&"
import script from "./ActivationPaymentsPreviewRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationPaymentsPreviewRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports